"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gte = void 0;
const gte = ({ leftValue, rightValue, }) => {
    if (leftValue === null || leftValue === undefined) {
        return { error: null, result: false };
    }
    if (rightValue === null || rightValue === undefined) {
        return { error: null, result: false };
    }
    if (Array.isArray(leftValue) || Array.isArray(rightValue)) {
        return {
            error: `Invalid comparison for greater than or equal to (>=): array provided as value`,
        };
    }
    const result = leftValue >= rightValue;
    return { error: null, result };
};
exports.gte = gte;
//# sourceMappingURL=gte.js.map